import type { Check } from './OrderActionsChecks.js'
import type { OrderContextActionsProps } from './OrderContextActionsWidget.js'
import { useGetAuthenticatedUser } from '../../../../Flux/Selector/index.js'
import { MenuButton } from './MenuButton.js'
import React from 'react'
import { useModal } from '../../../Modal/UseModal.js'
import type { NoticeTargetKey } from '../../../../Generated/NoticeTarget.ts'
import type { OrderNotice } from '../../../../Generated/OrderNotice.ts'
import { openNoticesFor } from '../../../../Model/Order/orderNotices.ts'
import { AlertMarker } from '../../../Component/OrderAlert/AlertMarker.tsx'

interface GatedActionConfig {
  label: string
  onClick: () => void
  gates?: Check[]
  props: OrderContextActionsProps
  labelClassName?: string
  tooltip?: string
  icon?: React.ReactNode
  requiresAuth?: boolean
  testId?: string
  /** Telemetry to fire when the action is actually invoked (after the auth gate passes). */
  track?: () => void
  /** The open notices concerning this action mark its menu entry. */
  noticeTarget?: NoticeTargetKey
}

export const gatedActions = (configs: GatedActionConfig[], hideDisabled: boolean, notices: OrderNotice[] = []) => {
  const user = useGetAuthenticatedUser()
  const { openModal } = useModal()

  return configs
    .map((config) => {
      const failingGate = config.gates?.map((g) => g(config.props, user)).find((g) => !g.check())
      const disabled = !!failingGate

      if (disabled && hideDisabled) return null

      return (
        <MenuButton
          key={config.label}
          label={config.label}
          testId={config.testId}
          onClick={() => {
            if (!user && config.requiresAuth !== false) {
              openModal('signupNudge', {})
            } else {
              config.track?.()
              config.onClick()
            }
          }}
          props={config.props}
          labelClassName={config.labelClassName}
          tooltip={config.tooltip}
          disabledTooltip={failingGate?.message}
          icon={config.icon}
          marker={markerFor(config.noticeTarget, notices)}
          disabled={disabled}
        />
      )
    })
    .filter(Boolean) // Remove nulls
}

const markerFor = (target: NoticeTargetKey | undefined, notices: OrderNotice[]) => {
  const open = target ? openNoticesFor(notices, target) : []
  return open.length > 0 ? <AlertMarker items={open} /> : undefined
}
